<template>
  <div class="integral-rank">
    <!-- 个人积分排行榜 -->
    <div class="personal-integral">
      <Title name="个人积分排行榜"/>
      <CapsuleTab
        :selected="personalSelected"
        @change='handlePersonalChange'/>
      <Loading class="loading-wrapper" v-if="personalShowLoading" size='20px'>加载中...</Loading>
      <template v-else>
        <div class="bs-wrapper">
          <div
            :class="`personal-integral-list`"
            ref="personal-integral-list"
            v-if="personalIntData.length > 0"
          >
            <RankItem
              v-for="(item, index) in personalIntData"
              :key="index"
              type="integral"
              :rank="index+1"
              :avatar="item.headimgUrl"
              :nickname="item.nickName"
              :intro="item.about"
              :dataNumber="item.count"
            />
            <Loading class="loading-end" v-if="personalEndLoading" size='20px'>加载中...</Loading>
            <div v-else class="loading-empty"></div>
          </div>
          <Empty v-else/>
        </div>
        <div class="rank-more" @click="handleLink(1)">查看历史排行榜>></div>
      </template>
    </div>
    <!-- 车队积分排行榜 -->
    <div class="team-integral">
      <Title name="车队积分排行榜"/>
      <CapsuleTab
        :selected="teamSelected"
        @change='handleTeamChange'/>
      <Loading class="loading-wrapper team-loading" v-if="teamShowLoading" size='20px'>加载中...</Loading>
      <template v-else>
        <div
          class="team-integral-list"
          v-if="teamIntData.length > 0"
        >
          <RankItem
            v-for="(item, index) in teamIntData"
            :key="index"
            type="integral"
            :rank="index+1"
            :avatar="item.headimgUrl"
            :nickname="item.teamName"
            :intro="item.address"
            :dataNumber="item.count"
          />
        </div>
        <Empty class="team-empty" v-else/>
        <div class="rank-more" @click="handleLink(2)">查看历史排行榜>></div>
      </template>
    </div>
    <div class="rank-end">榜单整点刷新</div>
  </div>
</template>

<script>
// 积分排行榜
import Title from '../Title'
import RankItem from '../RankItem'
import CapsuleTab from '../CapsuleTab'
import Empty from '../Empty'
import { Toast, Loading } from 'vant'
import {
  getPersonalWeekIntegral, getPersonalMonthIntegral, getPersonalAllIntegral,
  getTeamWeekIntegral, getTeamMonthIntegral, getTeamAllIntegral
} from '@/api/rank'

export default {
  name: 'RankIntegral',
  components: {
    Loading, Title, RankItem, CapsuleTab, Empty
  },
  props: [ 'bscroll' ],
  created () {
    this.getPersonalIntegralData()
    this.getTeamIntegralData()
  },
  beforeDestroy () {
    this.destroySCroll()
  },
  data () {
    return {
      personalSelected: 1, // 个人积分榜选中的tab(1-周榜，2-月榜，3-总榜)
      teamSelected: 1, // 车队积分榜选中的tab
      personalIntData: [], // 个人积分排行榜数据
      teamIntData: [], // 车队积分排行榜数据
      personalShowLoading: false,
      personalLoading: false,
      teamShowLoading: false,
      teamLoading: false,
      personalEndLoading: false,
      parentBS: null,
      childBS: null,
      personalPagination: {
        page: 1,
        size: 10,
        total: 0
      }
    }
  },
  methods: {
    // 获取个人积分数据
    getPersonalIntegralData (showLoading = false, loadingDelay = -1, page) {
      const reqFun = this.getReqFun('personal')
      this.personalShowLoading = showLoading
      this.personalLoading = true
      page = page || this.personalPagination.page
      const { size } = this.personalPagination
      reqFun({ page, size }).then(res => {
        if (res.data.code === 0) {
          // console.log(res.data.data)
          this.personalPagination.total = res.data.data.total
          this.personalIntData = page === 1 ? res.data.data.items : this.personalIntData.concat(res.data.data.items)
        } else {
          throw new Error(res.data)
        }
        this.$nextTick(() => {
          if (page === 1) {
            this.initBScroll(500, this.personalIntData.length)
          } else {
            this.childBS && this.childBS.finishPullUp()
            this.childBS && this.childBS.refresh()
          }
        })
        this.hideLoading('personal', loadingDelay)
      }).catch(() => {
        Toast.fail('网络请求异常')
        this.hideLoading('personal', loadingDelay)
      })
    },
    initBScroll (dealay = 200, length) {
      const BScroll = this.bscroll
      this.destroySCroll()
      const config = {
        scrollY: true,
        nestedScroll: true,
        click: true
      }
      setTimeout(() => {
        this.parentBS = new BScroll('.ranking-scroll', {
          ...config,
          bounce: {
            top: false,
            bottom: false
          }
        })
        if (length > 5) {
          this.childBS = new BScroll('.bs-wrapper', {
            ...config,
            pullUpLoad: true
          })
          this.childBS.on('pullingUp', this.onReachBottom)
          this.childBS.refresh()
        }
        this.parentBS.refresh()
      }, dealay)
    },
    destroySCroll () {
      this.parentBS && this.parentBS.destroy()
      this.childBS && this.childBS.destroy()
    },
    // 获取车队积分数据
    getTeamIntegralData (showLoading = false, loadingDelay = -1) {
      const reqFun = this.getReqFun('team')
      this.teamShowLoading = showLoading
      this.teamLoading = true
      reqFun({ page: 1, size: 10 }).then(res => {
        if (res.data.code === 0) {
          // console.log(res.data.data)
          this.teamIntData = res.data.data.items
        } else {
          throw new Error(res.data)
        }
        this.hideLoading('team', loadingDelay)
      }).catch(() => {
        Toast.fail('网络请求异常')
        this.hideLoading('team', loadingDelay)
      })
    },
    // loading隐藏
    hideLoading (type, delay = -1) {
      if (delay < 0) {
        if (type === 'personal') {
          this.personalLoading = false
          this.personalShowLoading = false
          this.personalEndLoading = false
        }
        if (type === 'team') {
          this.teamLoading = false
          this.teamShowLoading = false
        }
      } else {
        if (type === 'personal') {
          setTimeout(() => {
            this.personalLoading = false
            this.personalShowLoading = false
          }, delay)
        }
        if (type === 'team') {
          setTimeout(() => {
            this.teamLoading = false
            this.teamShowLoading = false
          }, delay)
        }
      }
    },
    getReqFun (type) {
      if (type === 'personal') {
        if (this.personalSelected === 1) { return getPersonalWeekIntegral }
        if (this.personalSelected === 2) { return getPersonalMonthIntegral }
        if (this.personalSelected === 3) { return getPersonalAllIntegral }
      }
      if (type === 'team') {
        if (this.teamSelected === 1) { return getTeamWeekIntegral }
        if (this.teamSelected === 2) { return getTeamMonthIntegral }
        if (this.teamSelected === 3) { return getTeamAllIntegral }
      }
    },
    // 个人榜单切换
    handlePersonalChange (index) {
      // 点击当前tab不处理
      if (this.personalSelected !== index) {
        this.personalSelected = index
        this.personalPagination.page = 1 // 重回首页
        this.$nextTick(() => {
          this.getPersonalIntegralData(true, 200)
        })
      }
    },
    // 车队榜单切换
    handleTeamChange (index) {
      if (this.teamSelected !== index) {
        this.teamSelected = index
        this.$nextTick(() => {
          this.getTeamIntegralData(true, 200)
        })
      }
    },
    // 个人积分排行榜触底事件
    onReachBottom () {
      // console.log('onReachBottom')
      const { page, size, total } = this.personalPagination
      const maxPage = Math.ceil(total / size)
      if (page + 1 <= maxPage) {
        this.personalPagination.page = page + 1
        this.$nextTick(() => {
          this.personalEndLoading = true
          this.getPersonalIntegralData(false, -1, this.personalPagination.page)
        })
      } else {
        // 数据加载完成
        this.personalEndLoading = false
      }
    },
    // 历史排行榜链接跳转
    handleLink (index) {
      let range
      // 个人积分
      if (index === 1) {
        range = this.personalSelected
      }
      // 车队积分
      if (index === 2) {
        range = this.teamSelected
      }
      this.$router.push(`/rankinghistory?type=${index}&range=${range}`)
    }
  }
}
</script>

<style lang="less">
.loading-wrapper{
  text-align: center;
  padding-top: 25px;
  &.team-loading{
    padding: 112px 0;
  }
}
.loading-end{
  padding: 20px 0;
  text-align: center;
}
.loading-empty{
  width: 100%;
  padding: 20px 0;
}
.bs-wrapper{
  margin-top: 10px;
  max-height: 330px;
  overflow: hidden;
}
.personal-integral{
  &-list{
    padding-top: 15px;
    & .rank-item-wrapper:nth-last-child(2){
      margin-bottom: 0;
    }
  }
}
.team-integral{
  padding-bottom: 25px;
  &-list{
    padding-top: 25px;
  }
}
.team-empty img{
  padding: 37px 0;
}
</style>
